import { nativePageParams } from '~/nativeLenses/pageRoutes';

/** Older direct hotel links used a key now reserved by the shared Lens workspace. */
export function lpcHealthParams(search: string): URLSearchParams {
  const incoming = new URLSearchParams(search);
  const params = nativePageParams(search);
  const legacy = incoming.get('view');
  if (!params.has('healthView') && (legacy === 'hotel' || legacy === 'portfolio')) params.set('healthView', legacy);
  return params;
}
